import { styled } from 'styles/stitches.config'
import { rem } from 'polished'

export const Features = styled('div', {

  '&:not(:last-of-type)': {
    marginBottom: 48
  },

  '& p': {
    marginLeft: 13,

    fontFamily: '$raleway',
    fontSize: rem(13),
    color: '$grey600',
  },
})

export const Grid = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: '14px',

  '@sm': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
})

export const Title = styled('h3', {
  marginBottom: 22,
})

export const Item = styled('div', {
  display: 'flex',
  alignItems: 'center',
})
